import { useEffect, useMemo, useState } from "react";
import { css } from "@emotion/react";

import { Tweet } from ".";

import { useGetMediaSize, useIsPC } from "../../hooks";

const SNS: React.FC = () => {
  const [xPostID, setXPostID] = useState<string | undefined>(undefined);

  const isPC = useIsPC();
  const { width } = useGetMediaSize({ max: 550 });
  const height = useMemo(() => {
    return isPC ? width * 1.25 : width;
  }, [width]);
  const tweetID = useMemo(() => "1720002819497791993", []);

  useEffect(() => {
    // コンポーネントのマウント時にデータを取得
    const fetchData = async () => {
      try {
        // APIエンドポイントURL
        const url =
          "https://x-post.microcms.io/api/v1/x_post_id?orders=-publishedAt";

        // fetchを使用してデータをGET
        const response = await fetch(url, {
          headers: {
            "X-MICROCMS-API-KEY": process.env.REACT_APP_MICROCMS_API_KEY || "",
          },
        });
        const data = await response.json();
        // 最新の投稿をstateにセット
        if (data.contents.length > 0) {
          const latestPost = data.contents[0];
          const latestID = latestPost.xPostID;
          setXPostID(latestID);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); // useEffectの依存配列を空にして、コンポーネントのマウント時のみ実行する

  return (
    <>
      <div css={mainStyle} id="X">
        <div css={contentsWrapper}>
          <div css={upperTitleWrapperStyle}>
            <div css={titleStyle}>
              What's New (<span css={fontSizeStyle(23, 16)}>X</span>)
            </div>
          </div>
          {width > 0 && xPostID && (
            <div css={twitterWrapperStyle(height)}>
              <Tweet id={xPostID} width={width} height={height} />
            </div>
          )}
          <div css={bottomContentsWrapperStyle}>
            <a
              href="https://www.tiktok.com/@sundome_drama_tt"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH + "/img/logo-tiktok.png"
                }
                alt="TikTok"
                css={tiktokImgStyle}
              />
            </a>
            <div css={subTitleStyle}>オリジナルコンテンツ配信中！</div>
          </div>
        </div>
      </div>
    </>
  );
};

const primaryColor = "#D90012";
const spSize = 768;

const mainStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const contentsWrapper = css`
  width: 100%;
  padding: 20px 20px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const titleStyle = css`
  margin-bottom: 10px;
  font-family: MyFont;
  font-size: 23px;
  font-weight: 500;
  line-height: 100%;

  @media (max-width: ${spSize}px) {
    font-size: 18px;
  }
`;

const subTitleStyle = css`
  padding-top: 10px;
  font-family: MyFont;
  font-size: 17.5px;
  font-weight: 500;
  line-height: 100%;

  @media (max-width: ${spSize}px) {
    font-size: 14px;
  }
`;

const fontSizeStyle = (num: number, spNum?: number) => css`
  font-size: ${num}px;
  @media (max-width: ${spSize}px) {
    font-size: ${spNum ? spNum : num}px;
  }
`;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const bottomContentsWrapperStyle = css`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const twitterWrapperStyle = (height: number) => css`
  position: relative;
  max-height: ${height}px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 7px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${primaryColor};
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.5);
  }
`;

const tiktokImgStyle = css`
  width: 150px;

  @media (max-width: ${spSize}px) {
    width: 120px;
  }
`;

export default SNS;
